export const FILTER_OPTIONS = {
  CATEGORY: 'main_category',
  SUB_CATEGORY: 'sub_category_one',
  SPACE: 'space',
  MATERIAL: 'main_material',
  COLOUR: 'colour',
};
